import { z } from 'zod';
import { PointSchema } from './geojson';

export const SensorTypeSchema = z.enum([
  'weather',
  'fire_detection',
  'air_quality',
  'traffic',
  'other',
]);
export type SensorType = z.infer<typeof SensorTypeSchema>;

export const SensorSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  type: SensorTypeSchema,
  location: PointSchema,
  metadata: z.record(z.unknown()).optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type Sensor = z.infer<typeof SensorSchema>;
